export default "__VITE_ASSET__cQSG4N0F__"